const keys = {
  WARNING: 'warning',
  SHOW_MORE: 'showMore',
  CLEAN: 'clean',
  CONTENT_PROVIDER_NOT_FOUND: 'contentProviderNotFound',
  CONTENT_IDENTIFIER_NOT_FOUND: 'contentIdentifierNotFound',
  CONTENT_TRANSFORMER_NOT_FOUND: 'contentTransformerNotFound',
  SELECTED_ITEM_FOUND: 'selectedItemFound',
  SELECTED_CONTENTS_WILL_BE_LOST: 'selectedContentsWillBeLost',
  EDITED_ITEM_FOUND: 'editedItemFound',
  EDITED_CONTENTS_WILL_BE_LOST: 'editedContentsWillBeLost',
  CHANGES_FOUND: 'changesFound',
  CHANGES_WILL_BE_LOST: 'changesWillBeLost',
};

export default keys;
